<template>
  <div class="box9" ref="box9">
    <pageTitle title="知名校友" />
    <div class="subject-box">
      <div class="pic-nav-box">
        <div
          class="nav"
          v-for="(item, index) in list"
          :key="index"
          :class="{ 'cur-nav': cur == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <img :src="item.pic" />
        </div>
        
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="box">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </swiper-slide>
      </swiper>
      
    </div>
  </div>
</template>

<script>

import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    let that = this;
    return {
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
        //   disableOnInteraction: false,
        // },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("pic-nav-box")[0].scrollLeft =
              this.realIndex * 100;
          }
        },
      },
      list:  [
         {
          title: "Herbert A. Simon",
          text: "人工智能代表人物，认知心理学先驱。美国国家科学院院士、诺贝尔经济学奖得主，1975年因其在人工智能等方面的基础研究获得ACM图灵奖，开发了最早的AI程序设计语言IPL语言，在政治学、经济学、心理学和计算机科学领域做出了杰出贡献。",
          pic: require("../../../assets/coursePage/illinois/box9/pic1.png"), 
        },
        {
          title: "Robert W. Floyd",
          text: "计算机科学领域有史以来最伟大的先驱之一，ACM图灵奖得主，前后断言法的创始人，堆排序算法和Floyd - Warshall算法的创始人之一。",
          pic: require("../../../assets/coursePage/illinois/box9/pic2.png"), 
        },
        {
          title: "Lee de Forest",
          text: "真空三极管的发明者，被誉为无线电之父、电视始祖、电子管之父。该发明推动了无线电以及其他电子行业的发展，例如广播、电视和雷达等。他也是一名多产的科学家，拥有超过300项专利。",
          pic: require("../../../assets/coursePage/illinois/box9/pic3.png"), 
        },
        {
          title: "Marty Cooper",
          text: "IIT优秀的校友，是无线通信技术领域的先驱，致力推动移动电话的研发，后在硅谷创办了自己的通讯技术研究公司一Array - Comm公司，并亲自担任公司董事长兼首席执行官。",
          pic: require("../../../assets/coursePage/illinois/box9/pic4.png"), 
        }
      ],
      cur: 0,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
    },
  },
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 80px 0 0;
  background: #fff;
  width: 100%;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #272020;
    line-height: 64px;
    text-align: center;
  }
  .subject-box {
    box-sizing: border-box;
    padding: 0 40px;
    position: relative;
    margin: 48px auto 0;
    overflow: hidden;
    .pic-nav-box::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }

    .pic-nav-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      overflow: auto;
      .nav {
        border-radius: 3px;
        border: 3px solid #fff;
        img {
          width: 152px;
          height: 152px;
        }
      }
      .cur-nav {
        border: 3px solid #D83F3F;
      }
    }
    .swiper-container{
      padding: 38px 0 80px;
    }
    .swiper-slide {
      width: 622px;
      height: 366px;
      background: #F4F4FB;
      border-radius: 24px;
      padding: 40px;
      box-sizing: border-box;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 40px;
        color: #272020;
        line-height: 56px;
        text-align: left;
      }
      .text {
        margin-top: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #272020;
        line-height: 44px;
        text-align: left;
      }
      img {
        width: 558px;
        height: 380px;
      }
    }
  }

}
</style>
